/**
 * 客户
 */

import React from 'react';
import { getData } from '@util';
import { Select, Spin, Icon } from 'antd';
import { Debounce, Bind } from 'lodash-decorators';
import {
  API_GET_LIKE_SELECT_SON_CUSTOMER_LIST, // 子客户
  API_GET_LIKE_SELECT_CUSTOMER_LIST, // 客户
} from '@api';
const { Option } = Select;

class CustomerCom extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      CustomerDataList: [],
      Customerloading: false,
    };
  }

  @Bind()
  @Debounce(1000)
  getSelectCustomer(val) {
    const { isPrincipalCustomer } = this.props;
    if (!val) return false;
    this.setState({
      Customerloading: true,
    });
    getData({
      api: isPrincipalCustomer
        ? API_GET_LIKE_SELECT_CUSTOMER_LIST
        : API_GET_LIKE_SELECT_SON_CUSTOMER_LIST,
      searchParams: {
        key: val,
        pageSize: 10,
      },
    }).then(res => {
      const { data, result } = res;
      this.setState({
        Customerloading: false,
        CustomerDataList: isPrincipalCustomer ? [...result] : [...data],
      });
    });
  }

  render() {
    const { CustomerDataList, Customerloading } = this.state;
    const { isSingleSelect, onChange, render, ...others } = this.props;
    return (
      <Select
        showSearch
        filterOption={false}
        allowClear
        showArrow
        dropdownMatchSelectWidth={false}
        placeholder="请输入关键词"
        tokenSeparators={[' ']}
        suffixIcon={<Icon type="search" />}
        className="multiple-select-and-search"
        mode={isSingleSelect ? null : Customerloading ? 'multiple' : 'tags'}
        notFoundContent={Customerloading ? <Spin pagesize="small" /> : null}
        onSearch={this.getSelectCustomer}
        onChange={(x, options) => {
          if (!isSingleSelect) {
            const y = Array.from(new Set(x));
            onChange && onChange(y, options);
          } else {
            onChange && onChange(x, options);
          }
        }}
        {...others}>
        {CustomerDataList.map(item => (
          <Option
            name={item.custName}
            title={`${item.custCode}${item.custName}`}
            key={item.custCode}
            value={render ? render(item) : item.custCode}>
            {item.custCode}
            {item.custName}
          </Option>
        ))}
      </Select>
    );
  }
}
export default CustomerCom;
